// 公司设置接口
import http from "../httpConfig"
const table = "mrbase_sys_org_levels"
//  新增公司
export const get_company_add = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/org/levels/add-company/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 公司列表
export const get_company_list = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/org/levels/list-company/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 公司删除
export const get_company_del = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/org/levels/delete-company/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 单位设定 单位详情 /api/org/levels/find-company/v1
export const get_company_info = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/org/levels/find-company/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 单位修改 /api/org/levels/update-company/v1
export const get_company_update = (params = {}) => {
  params["~table~"] = table
  return new Promise((resolve, reject) => {
    http
      .post("/api/org/levels/update-company/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 语言新增修改 /api/company_language_time_zone/add-language_time_zone/v1
export const lang_add = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_language"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company_language_time_zone/add-language_time_zone/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 语言新增修改 /api/company_language_time_zone/update-language_time_zone/v1
export const lang_update = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_language"
  return new Promise((resolve, reject) => {
    http
      .post(
        "/api/company_language_time_zone/update-language_time_zone/v1",
        params
      )
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 语言查询 /api/company_language_time_zone/find-language_time_zone/v1
export const lang_find = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_language"
  return new Promise((resolve, reject) => {
    http
      .post(
        "/api/company_language_time_zone/find-language_time_zone/v1",
        params
      )
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 语言删除 /api/company_language_time_zone/delect-language_time_zone/v1
export const lang_del = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_language"
  return new Promise((resolve, reject) => {
    http
      .post(
        "/api/company_language_time_zone/delect-language_time_zone/v1",
        params
      )
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 公司基本资料新增修改 /api/company/add-update-company/v1
export const add_update_baseData = (params = {}) => {
  params["~table~"] = "mrbase_sys_company"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company/add-update-company/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 删除公司基本资料 /api/company/delete-company/v1
export const del_baseData = (params = {}) => {
  params["~table~"] = "mrbase_sys_company"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company/delete-company/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 基本资料详情 /api/company/find-company/v1
export const find_baseData = (params = {}) => {
  params["~table~"] = "mrbase_sys_company"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company/find-company/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

/**
 * 公司认证信息配置
 */
//新增或修改认证信息配置
export const add_update_auth = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_auth"
  return new Promise((resolve, reject) => {
    http
      .post("/api/base/auth/auth-config/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 查询认证信息配置
export const find_auth = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_auth"
  return new Promise((resolve, reject) => {
    http
      .post("/api/base/auth/find-auth-config/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
/**
 * 汇率 增删改查
 */
// 汇率列表 /api/company_exchange_rate/list-exchange/v1
export const rate_list = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_exchange_rate"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company_exchange_rate/list-exchange/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 汇率详情 /api/company_exchange_rate/find-exchange/v1
export const rate_detail = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_exchange_rate"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company_exchange_rate/find-exchange/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 汇率新增修改 /api/company_exchange_rate/add-update-exchange/v1
export const rate_update_add = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_exchange_rate"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company_exchange_rate/add-update-exchange/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 汇率单个删除 /api/company_exchange_rate/delete-exchange/v1
export const rate_del = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_exchange_rate"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company_exchange_rate/delete-exchange/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 汇率多个删除 /api/company_exchange_rate/delete-levels-exchange/v1
export const rate_del_all = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_exchange_rate"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company_exchange_rate/delete-levels-exchange/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 邮箱新增修改 /api/company_email/add-update-email/v1
export const mail_update_add = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_email_smtp"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company_email/add-update-email/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 邮箱删除 /api/company_email/delete-email/v1
export const mail_del = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_email_smtp"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company_email/delete-email/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 邮箱查询 /api/company_email/find-email/v1
export const mail_info = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_email_smtp"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company_email/find-email/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 发送邮件接口
export const sendMail = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_email_smtp"
  return new Promise((resolve, reject) => {
    http
      .post("/api/mail/send-mail/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 公司属性
// 列表
export const companyAttrList = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_property"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company_property/list-property/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
// 新增修改
export const companyAttrUpdate = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_property"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company_property/update-property/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 公司属性详情 /api/company_property/find-property/v1
export const companyAttrInfo = (params = {}) => {
  params["~table~"] = "mrbase_sys_company_property"
  return new Promise((resolve, reject) => {
    http
      .post("/api/company_property/find-property/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

// 获取公司logo
export const getCompanyLogo = (params = {}) => {
  return new Promise((resolve, reject) => {
    http
      .post("/api/company/get-company-logo/v1", params)
      .then((res) => {
        resolve(res)
      })
      .catch((err) => {
        reject(err)
      })
  })
}
